<section>
  <div class="row mx-0">
    <form class="container-style" novalidate [formGroup]="formSubrentalCutoff" errorTailor>
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-chip class="me-1" *ngIf="previewSubrentalCutoff"
              [label]="'Corte: ' + subrentalCutoffContract.consecutive" />

            <app-custom-button [title]="titlePreviewSubrentalCutoff" [severity]="'contrast'"
              [icon]="iconPreviewSubrentalCutoff" (onClick)="openPreviewSubrentalCutoff()"></app-custom-button>
            <app-custom-button *ngIf="previewSubrentalCutoff" [title]="'Exportar excel'" [severity]="'contrast'"
              [icon]="'pi pi-file-excel'" (onClick)="exporterDetailsPreviewPrint()"></app-custom-button>
            <app-custom-button *ngIf="previewSubrentalCutoff" [title]="'Imprimir'" [severity]="'contrast'"
              [icon]="'pi pi-print'" (onClick)="printLiquidated()"></app-custom-button>
            <app-custom-button [hidden]="previewSubrentalCutoff" [title]="'Eliminar'" [severity]="'contrast'"
              [icon]="'pi pi-trash'" (onClick)="deleteSubrentalCutoff()"></app-custom-button>


            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewSubrentalCutoff(0)"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row px-0 mx-0" [hidden]="previewSubrentalCutoff">
          <div class="row px-0 mx-0">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="subrentalCutoffContract.userNameCreate"
                [createDate]="subrentalCutoffContract.createDate"
                [userNameUpdate]="subrentalCutoffContract.userNameUpdate"
                [updateDate]="subrentalCutoffContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row px-0 mx-0">
            <div class="row px-0 mx-0">
              <div class="col field-branch">
                <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
                  [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)">
                </app-custom-select>
              </div>
              <div class="col col-sm-auto field-consecutive">
                <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                  [recovery]="true" (onChangeNumber)="changeConsecutive($event)"></app-custom-input-number>
              </div>
              <div class="col field-date-cutoff">
                <app-custom-datepicker formControlName="dateSubrentalCutoff" [labelText]="'Fecha Corte'"
                  [required]="true"></app-custom-datepicker>
              </div>
              <div class="col field-state-buttons d-flex align-items-end">
                <app-custom-modal #liquidatedModal [label]="'Liquidación'" [header]="'Liquidación'"
                  [children]="liquidatedComponent" [inputs$]="inputsForLiquidatedModal$" [closable]="false"
                  [width]="'70rem'" (params)="updateSubrentalCutoff($event)" hidden></app-custom-modal>
                <app-custom-button [id]="'btnLiquidatedModal'" [title]="'Liquidación'" [label]="liquidatedCutoffLabel"
                  [width]="'5rem'" [severity]="'primary'" [disabled]="!disabledState" (onClick)="openLiquidatedModal()">
                </app-custom-button>
              </div>
              <div class="col field-state">
                <app-custom-tag [label]="'Estado'" [value]="subrentalCutoffStateString"
                  [severity]="subrentalCutoffContract.subrentalCutoffStateId === subrentalStateOpen ? 'danger' : ''">
                </app-custom-tag>
              </div>
              <div class="col field-change-state d-flex align-items-end">
                <app-custom-button [title]="stateButtonLabel()" [icon]="stateButtonIcon()" [severity]="'primary'"
                  (onClick)="changeState()"></app-custom-button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col field-observation">
              <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                [autoResize]="false" [maxLength]="250"></app-custom-textarea>
            </div>
            <div class="field-save d-flex align-items-end">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disabledForm" [variant]="undefined"
                (onClick)="send()"></app-custom-button>
            </div>
            <div class="field-add-store d-flex align-items-end">
              <app-custom-button [id]="'btnSubrentalCutoffStore'" [title]="'Agregar Bodegas'"
                [label]="'Agregar Bodegas'" [width]="'9rem'" [icon]="'pi pi-plus-circle'"
                [disabled]="disabledSelectStore" (onClick)="openSelectStoreModal()">
              </app-custom-button>
              <app-custom-modal #selectStore [label]="'Selección de Bodegas'" [header]="'Seleccionar Bodegas'"
                [children]="componentTableSelection" [inputs$]="inputsForStoreModal$" [output$]="output$"
                [width]="'60rem'" (selectedItems)="createDetail($event)" hidden>
              </app-custom-modal>
            </div>
          </div>
        </div>
      </div>
      <app-preview-liquidation id="print-preview-liquidation" *ngIf="previewSubrentalCutoff" [companyId]="companyId"
        [formatModel]="formatModel" [liquidationPrintModel]="liquidationPrintModel" [editFormat]="false"
        [exporterDetailsPreview]="exporterDetailsPreview" (finishLoadingPrint)="visiblePreview($event)"
        (filtersPreview)="getFilterPreview($event)"></app-preview-liquidation>
    </form>
    <div [hidden]="previewSubrentalCutoff" class="p-0 mt-2">
      <app-subrental-cutoff-detail [subrentalCutoffModel]="subrentalCutoffContract" [rowsEditable]="disabledDetail"
        [updateSubrentalCutoffListDetail]="updateListDetail" (quantityDetails)="getQuantityDetails($event)">
      </app-subrental-cutoff-detail>
    </div>
  </div>
</section>